import { render, staticRenderFns } from "./SeriesSelectedFunds.vue?vue&type=template&id=499c5a95&scoped=true&"
import script from "./SeriesSelectedFunds.vue?vue&type=script&lang=js&"
export * from "./SeriesSelectedFunds.vue?vue&type=script&lang=js&"
import style0 from "./SeriesSelectedFunds.vue?vue&type=style&index=0&id=499c5a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c5a95",
  null
  
)

export default component.exports